import { useState, type FormEvent } from "react";
import { useNavigate } from "@tanstack/react-router";
import { Button, theme } from "@dfws/ui";
import { useLogin } from "../../lib/queries";
import { ApiFailure } from "../../lib/api";
import s from "./LoginView.module.css";

export function LoginView() {
  const login = useLogin();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    try {
      await login.mutateAsync({ email: email.trim(), password });
      await navigate({ to: "/mail/$folder", params: { folder: "inbox" } });
    } catch {
      /* shown below */
    }
  }

  const error = login.error instanceof ApiFailure ? login.error.message : login.error ? "Something went wrong. Try again." : null;

  return (
    <main className={s.page}>
      <div className={s.card}>
        <img src={theme.logo.mark} alt="" width={44} height={44} className={s.mark} />
        {/* Brand moment: Outfit for the sign-in title */}
        <h1 className={s.title}>Sign in to Workspace</h1>
        <p className={s.lead}>Use your DevFusion email address and password.</p>
        <form className={s.form} onSubmit={onSubmit} noValidate>
          <label className={s.field}>
            <span>Email address</span>
            <input type="email" autoComplete="username" inputMode="email" required autoFocus value={email} onChange={(e) => setEmail(e.target.value)} aria-invalid={Boolean(error) || undefined} />
          </label>
          <label className={s.field}>
            <span>Password</span>
            <input type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} aria-invalid={Boolean(error) || undefined} />
          </label>
          {error && (
            <p className={s.error} role="alert">
              {error}
            </p>
          )}
          <Button type="submit" variant="primary" loading={login.isPending} disabled={!email || !password} className={s.submit}>
            {login.isPending ? "Signing in" : "Sign in"}
          </Button>
        </form>
        <p className={s.note}>Your password is checked by the DevFusion mail server and never stored by Workspace.</p>
      </div>
    </main>
  );
}
